import React from 'react';
import { BLACKS_AND_WHITES } from '../../utils/DataFormatterUtils';
import { Row } from 'antd';

export const CostAndScopeBreakdown = ({ label, showComparison, lastRecord = {} }) => {
	if (!showComparison) return null;

	return (
		<Row style={{ alignItems: 'baseline', marginBottom: 20 }}>
			<h5 style={{ marginBottom: 0 }}>Cost & Scope Breakdown</h5>
			<span
				style={{
					color: BLACKS_AND_WHITES.blackSecondary,
					marginLeft: 12,
				}}
			>
				Changes from the previous{' '}
				{lastRecord.hasOwnProperty('approvedAt')
					? 'approved '
					: lastRecord.hasOwnProperty('disputedAt')
					? 'disputed '
					: null}
				{label} are shown below
			</span>
		</Row>
	);
};
